import { CSSProperties, useLayoutEffect } from 'react';
import { useRafState } from 'react-use';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import useNavigationStore from 'src/stores/useNavigationStore';

/**
 * Determines the height and top position of the side drawer, based on the space
 * between the top edge of the screen and main content, which can be dynamic,
 * as we conditionally render elements there (e.g. banners).
 */
export default function useSideDrawerStyle() {
	const isMobileScreenSize = useIsMobileScreenSize();

	const currentNavigationCategory = useNavigationStore(
		(s) => s.currentNavigationCategory
	);
	const isTradePage = currentNavigationCategory === 'trade';

	const [sideDrawerStyle, setSideDrawerStyle] = useRafState<CSSProperties>({});

	useLayoutEffect(() => {
		const updateTopBarHeight = () => {
			const topBar = document.getElementById('topbar');

			if (!topBar) {
				return;
			}

			const { bottom } = topBar.getBoundingClientRect();

			setSideDrawerStyle({
				top: isMobileScreenSize ? 0 : bottom,
				height: isMobileScreenSize ? '100vh' : `calc(100vh - ${bottom}px)`,
			});
		};

		updateTopBarHeight();
		window.addEventListener('resize', updateTopBarHeight);

		return () => {
			window.removeEventListener('resize', updateTopBarHeight);
		};
	}, [isTradePage, isMobileScreenSize]);

	return sideDrawerStyle;
}
